'use client';

import Image from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function WorksSection() {
  return (
    <div className="works-area pt-80 pb-50 bg-f7fafd">
      <div className="container">
        <div className="section-title">
          <h2 data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">Our Recent Works</h2>
          <div className="bar" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true"></div>
          <p data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
            At Eratec Solution, we transform ideas into powerful digital experiences.
            Here's a glimpse into some of our latest projects that showcase our commitment
            to innovation, quality, and excellence.
          </p>
        </div>

        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={10}
          slidesPerView={3}
          navigation
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          loop
          breakpoints={{
                          0: {
                            slidesPerView: 1, // Mobile (0px and up)
                          },
                          640: {
                            slidesPerView: 2, // Small tablets
                          },
                          1024: {
                            slidesPerView: 3, // Desktops
                          },
                        }}
          className="works-slides relative pb-8" // Add padding-bottom
        >
          {worksData.map((work, index) => (
            <SwiperSlide key={index}>
              <div className="single-works" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                {/* Project Image */}
                <Image
                  src={work.image}
                  alt="Work Image"
                  width={640}
                  height={450}
                  loading="lazy"
                />

               
                {/* Project Text Content */}
                <div className="works-content" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                  {/* Project Title with external link */}
                  <h3 data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
                    <a
                      href={work.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {work.title}
                    </a>
                  </h3>
                  {/* Project Description */}
                  <p data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">{work.description}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

// Project data array
const worksData = [
  {
    image: '/orientalTrimex.svg',
    title: 'Oriental Trimex Limited',
    link: 'https://www.orientaltrimex.com/',
    description:
      "Informative Website, Designed for a seamless user experience, company’s legacy, product range, and nationwide presence with a modern, responsive layout.",
  },
  {
    image: '/WannaInk.svg',
    title: 'Wanna Ink',
    link: 'https://wannaink.com/',
    description:
      "E-Commerce Website, offering a smooth user experience, showcasing personalized T-shirt designs and high-quality products with a sleek, responsive layout.",
  },
  {
    image: '/TheUniqueMugs.svg',
    title: 'The Unique Mugs',
    link: 'https://theuniquemugs.com/',
    description:
      "Blends traditional craftsmanship with a dynamic, responsive design, showcasing a diverse range of materials and artistry.",
  },
  {
    image: '/ThatHardwareStore.svg',
    title: 'That Hardware Store',
    link: 'https://www.thathardwarestore.com',
    description:
      "E-Commerce Website combining functionality and style, showcasing a wide hardware collection with a dynamic, adaptive design.",
  },
  {
    image: '/Sanvi.svg',
    title: 'Sanvi',
    link: 'https://www.sanvi.net/',
    description:
      "Elegant e-commerce platform highlighting Sanvi’s product range and brand story through a stylish, adaptive online experience.",
  },
  {
    image: '/MyraTrenzs.svg',
    title: 'Myra Trenzs',
    link: 'https://www.myratrendz.com/',
    description:
      "Clean, intuitive platform reflecting the brand’s fashion innovation and dynamic spirit through a fluid, stylish web experience.",
  },
  {
    image: '/kaushalInternational.svg',
    title: 'Kaushal International',
    link: 'http://b2c.kaushalinternational.com/',
    description:
      "Vibrant B2B website bringing global commerce to the forefront with extensive catalog and mobile-friendly design.",
  },
  {
    image: '/kanhapolyfab.svg',
    title: 'Kanha Polyfab',
    link: 'https://www.kanhapolyfab.com/',
    description:
      "Informative platform showcasing innovative textile and packaging solutions with a focus on quality and sustainability.",
  },
  {
    image: '/KalaNishtha.svg',
    title: 'KalaNishtha',
    link: 'https://www.kalanishtha.com/',
    description:
      "Immersive platform blending traditional art with modern design, featuring exclusive handcrafted artworks.",
  },
  {
    image: '/HomeHeartIndia.svg',
    title: 'Home Heart India',
    link: 'https://www.homeheartindia.com/',
    description:
      "E-commerce platform showcasing high-quality home decor products with a modern, user-centric design.",
  },
  {
    image: '/GodsGrace2.svg',
    title: 'Dr. Roshi Satija',
    link: 'http://drroshisatija.com/',
    description:
      "PHP-based website offering a user-friendly experience for fertility care and personalized IVF services.",
  },
  {
    image: '/GodsGrace1.svg',
    title: 'Gods Grace IVF Center',
    link: 'https://www.godsgraceivfcenter.com',
    description:
      "Informative website guiding individuals through their fertility journey with expert care and treatments.",
  },
  {
    image: '/BariaHouseLifting.svg',
    title: 'Baria House Lifting',
    link: 'https://www.bariahouselifting.com',
    description:
      "Streamlined platform showcasing expert house lifting and relocation services with a responsive design.",
  },
  {
    image: '/AlgnutraStore.svg',
    title: 'Algnutra Store',
    link: 'https://www.algnutrastore.com/',
    description:
      "E-commerce website offering a smooth experience for wellness products in a sleek, fully responsive design.",
  },
  {
  image: '/herbalpowerindia.png',
  title: 'Herbal Power India',
  link: 'https://herbalpowerindia.com/',
  description:
    "E-commerce website for herbal products, designed with a responsive interface and optimized for SEO, performance, and smooth user experience.",
  },
  {
  image: '/addlyssalon.png',
  title: "Addly's De Salon",
  link: 'https://addlyssalon.com/',
  description:
    "Modern unisex salon website showcasing premium beauty and grooming services with a responsive design optimized for SEO, performance, and user experience.",
  },
  {
  image: '/homeheartbrand.png',
  title: 'Home Heart Brands',
  link: 'https://www.homeheartbrands.com/',
  description:
    "USA-based e-commerce website for home décor and textile products, featuring a responsive design optimized for SEO, performance, and seamless user experience.",
  },
  {
  image: '/kicksdrink.png',
  title: 'Kick Drink',
  link: 'https://www.kickdrink.ae/',
  description:
    "Dubai-based beverage e-commerce website showcasing natural drinks with a responsive design optimized for SEO, performance, and user experience.",
  },
];
